import React from 'react';
import PanelSection from '../FormElements/PanelSection';

export default class UserEvents extends React.Component {
	constructor(props) {
		super(props);

		const data = this.props.data || [];

		this.state = {
			data: data,
			loading: data && data.length ? false : true
		};

		this.loadData = this.loadData.bind(this);
	}

	componentDidMount() {
		if (!this.state.data || this.state.data.length === 0) {
			this.loadData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.endpoint !== this.props.endpoint) {
			this.loadData();
		}
	}

	valueToStyle(value) {
		if (value === 'Yes' || value === 'Passed' || value >= 70) {
			return { backgroundColor: '#eaf6ec', color: '#28a745' };
		} else if (value >= 60 && value <= 69) {
			return { backgroundColor: '#FFF9E6', color: '#D49A00' };
		} else {
			return { backgroundColor: '#F3F4F7', color: '#414243' };
		}
	}

	render() {
		// console.log(this.props)
		let section = null;
		if (this.state.data) {
			console.log(this.state.data);
			section = (
				<div className="UserEvents">
					<PanelSection title={I18n.t('admin.user.events-title')}>
						<form className="form-container">
							<div className="form-group">
								<label>{this.state.data.name_label}</label>
								<span>{this.state.data.name_value}</span>
							</div>
							<div className="form-group">
								<label>{this.state.data.assessment_proctor_label}</label>
								<span>{this.state.data.assessment_proctor_value}</span>
							</div>
							<div className="form-group">
								<label>{this.state.data.is_tutorials_complete_label}</label>
								<span
									style={this.valueToStyle(
										this.state.data.is_tutorials_complete_value
									)}
								>
									{this.state.data.is_tutorials_complete_value}
								</span>
							</div>
							<div className="form-group">
								<label>{this.state.data.is_final_exam_taken_label}</label>
								<span
									style={this.valueToStyle(
										this.state.data.is_final_exam_taken_value
									)}
								>
									{this.state.data.is_final_exam_taken_value}
								</span>
							</div>
							<div className="form-group">
								<label>{this.state.data.is_final_paper_complete_label}</label>
								<span
									style={this.valueToStyle(
										this.state.data.is_final_paper_complete_value
									)}
								>
									{this.state.data.is_final_paper_complete_value}
								</span>
							</div>
							<div className="form-group">
								<label>{this.state.data.is_passed_exam_label}</label>
								<span
									style={this.valueToStyle(
										this.state.data.is_passed_exam_value
									)}
								>
									{this.state.data.is_passed_exam_value}
								</span>
							</div>
							<div className="form-group">
								<label>{this.state.data.final_checkup_label}</label>
								<span
									style={this.valueToStyle(this.state.data.final_checkup_value)}
								>
									{this.state.data.final_checkup_value}%
								</span>
							</div>
							<div className="form-group">
								<label>{this.state.data.is_survey_complete_label}</label>
								<span
									style={this.valueToStyle(
										this.state.data.is_survey_complete_valuee
									)}
								>
									{this.state.data.is_survey_complete_value}
								</span>
							</div>
						</form>
					</PanelSection>
				</div>
			);
		}

		return (
			<div>
				{this.state.loading ? (
					<div className="loadingOverlay">
						<div className="spinner" />
					</div>
				) : null}
				<div>{section}</div>
			</div>
		);
	}

	loadData() {
		this.setState({ loading: true });
		$.ajax({
			type: 'POST',
			url: this.props.endpoint
		}).done((data) => {
			//console.log('UserEvents loadData done', data);
			this.setState({ data: data, loading: false });
		});
	}
}
